module.exports = __webpack_public_path__ + "c806857f4fa1957a7495dc620e38c19e.svg";